<template>
    <div class="v-ikm-quick-settings">
        <SmartSelect v-model="requestSettings.year" :options="yearOptions" :label-fn="(v: number) => String(v)"
            class="v-ikm-quick-settings__select" title="Jahr" />
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { SmartSelect } from "gertrud";
import { IkmMapModule } from "@/mapModules/ikm/IkmMapModule";

const props = defineProps<{
    mapModule: IkmMapModule
}>();

const requestSettings = props.mapModule.reactiveData.requestSettings;

const yearOptions = computed(() => {
    // Provide a reasonable range of years for IKM monitoring data
    const currentYear = new Date().getFullYear();
    const years: number[] = [];
    for (let y = currentYear; y >= currentYear - 10; y--) {
        years.push(y);
    }
    return years;
});
</script>

<style scoped lang="scss">
.v-ikm-quick-settings {
    display: flex;
    align-items: center;
    gap: 6px;
}

.v-ikm-quick-settings__select {
    min-width: 70px;
    max-width: 100px;
}
</style>
